var styles = {
  "root": "Base-Notifications",
  "top_left": "Base-Notifications--TopLeft",
  "top_right": "Base-Notifications--TopRight",
  "top_center": "Base-Notifications--TopCenter",
  "bottom_left": "Base-Notifications--BottomLeft",
  "bottom_right": "Base-Notifications--BottomRight",
  "bottom_center": "Base-Notifications--BottomCenter",
  "item": "Base-Notifications--Item",
  "notification": "Base-Notifications--Notification",
  "body": "Base-Notifications--Body",
  "title": "Base-Notifications--Title",
  "description": "Base-Notifications--Description",
  "icon": "Base-Notifications--Icon",
  "notification_error": "Base-Notifications--NotificationError",
  "notification_success": "Base-Notifications--NotificationSuccess",
  "notification_notice": "Base-Notifications--NotificationNotice",
  "notification_warning": "Base-Notifications--NotificationWarning",
  "lg": "Base-Notifications--Lg",
  "md": "Base-Notifications--Md",
  "sm": "Base-Notifications--Sm",
  "icon_success": "Base-Notifications--IconSuccess",
  "icon_error": "Base-Notifications--IconError",
  "icon_warning": "Base-Notifications--IconWarning",
  "icon_notice": "Base-Notifications--IconNotice",
  "close": "Base-Notifications--Close"
};

export { styles as default };
